import { UserInfo } from 'src/app/interfaces';
import { ChatChannelType } from '../../chat/interfaces/chat-model.interface';

export enum MessengerMessagesTypes {
  text = 'text',
}

export interface MessengerMessage {
  channelType: ChatChannelType;
  messageAuthor: UserInfo;
  conversationParticipants: UserInfo[];
  messageType: MessengerMessagesTypes;
  channelLink: string;
  senderLink: string;
  isChannelUnread: boolean;
  isGroupMessage: boolean;
  messageBody: string;
  channelFriendlyName: string;
  channelUniqueName: string;
  dateCreated: Date;
}
